<template>
  <div class="tag-search-wrapper">
    <div class="tags-widget" ref="tagsWidget">
      <div class="tags-item" v-for="(item, index) in input_data.added" :key="index">
        <span>{{ item.name | validate }}</span>
        <button @click="removeItem(item, index)" class="close-btn">
          &times;
        </button>
      </div>
      <input v-if="false" type="text" class="item-input" :style="{ 'min-width': inputWidth }" v-model="tag_text"
        placeholder="" @keypress.enter="addTag()" @blur="addTag()" />

      <span :style="{ 'min-width': inputWidth }" class="item-input" ref="tagInput" placeholder="" @keyup="onKeyUp"
        @keypress.enter="addTag" role="textbox" contenteditable></span>
    </div>
    <img v-if="icon" :src="icon" alt="" class="input-icon">
    <div class="search-result">
      <ul v-if="search_result.length > 0">
        <li v-for="(item, index) in search_result" :key="index" @click="fillTag(item)">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "tags-widget",
  props: {
    value: {
      type: Object,
      default: () => {
        return { added: [], removed: [] };
      },
    },
    inputWidth: {
      type: String,
      default: "60px"
    },
    icon: {
      type: String,
      default: null
    },
    canAutoComplete: {
      type: Boolean,
      default: false
    },
    useSuggestionsOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input_data: { added: [], removed: [] },
      tag_text: "",
      search_result: [],
    };
  },
  computed: {},
  watch: {
    value(val) {
      let vm = this;
      vm.input_data.added = val.added;
    },
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.input_data.added = vm.value.added;
    }
  },
  methods: {
    onKeyUp(e) {
      let vm = this;
      vm.tag_text = e.target.innerText;
      if (vm.canAutoComplete) {
        vm.$emit("autoCompleteCallback", vm.tag_text, (data) => {
          vm.search_result = data;
        });
      }
    },
    addTag(e) {
      let vm = this;
      if (!vm.useSuggestionsOnly) {
        vm.search_result = [];
        if (vm.tag_text && vm.tag_text != '') {
          let obj = {
            name: vm.tag_text,
            value: null
          };
          vm.input_data.added.push(obj);
          vm.tag_text = "";
          vm.$emit("onSubmit", vm.input_data);
          vm.$emit("input", vm.input_data);
        }
        setTimeout(() => {
          e.target.innerText = "";
          vm.tag_text = "";
        }, 100);
      }
    },
    fillTag(item) {
      let vm = this;
      vm.search_result = [];
      vm.$refs.tagInput.innerText = "";
      if (item) {
        let obj = {
          name: item.name,
          value: item.value
        };
        vm.input_data.added.push(obj);
        vm.tag_text = "";
        vm.$emit("onSubmit", vm.input_data);
        vm.$emit("input", vm.input_data);
        vm.$refs.tagInput.focus();
        vm.$refs.tagsWidget.scrollLeft = vm.$refs.tagsWidget.scrollWidth;
      }
    },
    removeItem(item, index) {
      let vm = this;
      vm.input_data.added.splice(index, 1);
      if (item.on_update) {
        vm.input_data.removed.push(item.id);
      }
      vm.$emit("onSubmit", vm.input_data);
      vm.$emit("input", vm.input_data);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.tag-search-wrapper {
  border: 1px solid #ddd;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 5px;
  position: relative;

  .tags-widget {
    display: flex;
    border-radius: 5px;
    max-width: 220px;
    align-items: center;
    overflow-y: auto;


    .tags-item {
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #04a5a5;
      margin-right: 5px;
      margin-bottom: 2px;
      cursor: pointer;
      padding: 2px 10px;
      color: #fff;

      span {
        margin-right: 10px;
        font-size: 11px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .close-btn {
        background: #f5f5f5;
        color: rgb(75, 75, 75);
        height: 15px;
        width: 15px;
        font-size: 11px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .item-input {
      border: none;
      outline: none;
      width: max-content;
    }


  }

  .input-icon {
    width: 15px;
    height: 15px;
    margin-left: 5px;
  }

  .search-result {
    position: absolute;
    top: 30px;
    left: 0px;
    right: 0px;
    background-color: #fff;
    z-index: 999;
    max-height: 200px;
    overflow-y: auto;
    border-radius: 5px;
    box-shadow: 0px 0px 5px 0px #000000;

    ul {
      list-style: none;
      padding: 0px;
      margin: 0px;

      li {
        padding: 5px 10px;
        cursor: pointer;
        border-bottom: 1px solid #eee;

        &:hover {
          background: #eee;
        }
      }
    }
  }
}
</style>